/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-form';
import swal from 'sweetalert2';
import Steps, { Step } from 'rc-steps';
import Uppy from 'uppy/lib/core';
import { Dashboard } from 'uppy/lib/react';
import * as MesAct from '../../Actions/MesActions';
import { envoyerMessageNG, obtenirPrestations, envoyerMessageNGPJ, envoyerMessageNGHorsPJ } from '../../App_Code/API';
import { estVide } from '../../App_Code/Utils';
import { mapStateToPropsWrapper } from '../CaptureErreurs';
import { AfficherFeedback, Texte, ZoneTexte } from '../ChampFormulaire';

const MessagesAide = [
    /* Etape 1 */ 'Sélectionnez le type du message que vous voulez envoyer à votre syndic.',
    /* Etape 2 */ 'Choisissez une catégorie pour votre demande.',
    /* Etape 3 */ 'Vous pouvez maintenant saisir un message à votre syndic. Vous pouvez éventuellement joindre des fichiers.',
];

// const CatDemInt = [
//     { code: 'CHA', lib: 'Chauffage/Eau chaude' },
//     { code: 'ELE', lib: 'Électricité' },
//     { code: 'PLO', lib: 'Plomberie' },
//     { code: 'ASC', lib: 'Ascenseur' },
//     { code: 'POR', lib: 'Porte/Interphone/Barrière' },
//     { code: '', lib: 'Autre' },
// ];

// const CatDemDoc = [
//     { code: 'AG', lib: 'Assemblée générale' },
//     { code: 'AP', lib: 'Appel de fonds' },
//     { code: 'RB', lib: 'Relevé bancaire' },
//     { code: 'CE', lib: "Carnet d'entretien" },
//     { code: '', lib: 'Autre' },
// ];

/* const CatQuest = [
    { code: 'CHA', lib: 'Chauffage/Eau chaude' },
    { code: 'ELE', lib: 'Électricité' },
    { code: 'PLO', lib: 'Plomberie' },
    { code: 'NET', lib: 'Nettoyage/Poubelles/Désinsectisation' },
    { code: 'POR', lib: 'Porte/Interphone/Barrière' },
    { code: '', lib: 'Autre' },
]; */

const Types = [
    {
        Code: 'DEM', IdBureau: 121, Lib: 'Signaler un incident', Nom: 'Incident', Icone: 'fa-exclamation-triangle', Description: 'Vous avez besoin que votre syndic fasse intervenir un fournisseur dans la copropriété.',
    },
    {
        Code: 'DEM', IdBureau: 15, Lib: 'Demande personnelle', Nom: 'Demande personnelle', Icone: 'fa-user-friends', Description: 'Vous avez besoin de poser une question à votre syndic.',
    },
    {
        Code: 'DEM', IdBureau: 122, Lib: 'Question de comptabilité', Nom: 'Comptabilité', Icone: 'fas fa-calculator', Description: 'Vous avez besoin d\'en savoir plus sur votre comptabilité.',
    },
    /* {
        code: 'DEMDOC', lib: 'Demande de document', categories: CatDemDoc, icone: 'fa-file-alt', description: "Vous avez besoin d'un document qui n'est pas encore à votre disposition sur cet Extranet.",
    },
    {
        code: 'QUEST', lib: 'Question', categories: CatQuest, icone: 'fa-question', description: 'Pour les demandes qui ne correspondent pas aux catégories précédentes.',
    }, */
];

const francaisCore = {
    strings: {
        // youCanOnlyUploadX: {
        //     0: 'Vous pouvez joindre %{smart_count} fichier au maximum',
        //     1: 'Vous pouvez joindre %{smart_count} fichiers au maximum',
        // },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files',
        },
        exceedsSize: 'Ce fichier dépasse la taille maximale autorisée : ',
        youCanOnlyUploadFileTypes: 'Types de fichiers pris en charge :',
        uppyServerError: 'Connection with Uppy Server failed',
    },
};

const francaisDashboard = {
    strings: {
        selectToUpload: 'Select files to upload',
        closeModal: 'Close Modal',
        upload: 'Upload',
        importFrom: 'Import from',
        dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
        dashboardTitle: 'Uppy Dashboard',
        copyLinkToClipboardSuccess: 'Link copied to clipboard.',
        copyLinkToClipboardFallback: 'Copy the URL below',
        copyLink: 'Copy link',
        fileSource: 'File source',
        done: 'Done',
        name: 'Name',
        removeFile: 'Remove file',
        editFile: 'Edit file',
        editing: 'Editing',
        finishEditingFile: 'Finish editing file',
        localDisk: 'Local Disk',
        myDevice: 'My Device',
        dropPasteImport: 'Drop files here, paste, import from one of the locations above or',
        dropPaste: 'Glissez-déposez vos fichiers ici, ou',
        browse: 'cliquez ici pour les sélectionner',
        fileProgress: 'File progress: upload speed and ETA',
        numberOfSelectedFiles: 'Number of selected files',
        uploadAllNewFiles: 'Upload all new files',
        emptyFolderAdded: 'No files were added from empty folder',
        uploadComplete: 'Upload complete',
        resumeUpload: 'Resume upload',
        pauseUpload: 'Pause upload',
        retryUpload: 'Retry upload',
        uploadXFiles: {
            0: 'Upload %{smart_count} file',
            1: 'Upload %{smart_count} files',
        },
        uploadXNewFiles: {
            0: 'Upload +%{smart_count} file',
            1: 'Upload +%{smart_count} files',
        },
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}',
        },
    },
};

const PrestVide = {
    Code: '',
    Libelle: '',
    Couleur: '#000',
    Icone: '',
    Actif: true,
}

const Etapes = ({ etape, selection, etapePrecedente }) => (
    <div className="d-flex flex-row mb-3">
        <Steps className="mr-3" /* labelPlacement="vertical" */ current={etape}>
            <Step title={selection[0] && selection[0].Nom ? selection[0].Nom : 'Type du message'} icons={{finish: <i className="fas fa-check"/>}} />
            <Step title={selection[1] && selection[1].Libelle ? selection[1].Libelle : etape > 1 ? 'Aucune catégorie' : 'Choix de la catégorie'} icons={{ finish: <i className="fas fa-check" /> }}/>
            <Step title="Rédaction du message" icons={{ finish: <i className="fas fa-check" /> }} />
        </Steps>
        <button className="btn btn-secondary" onClick={() => etapePrecedente()} disabled={etape < 1}>
            Retour
        </button>
    </div>
);

const MessageAide = ({ etape }) => (
    <div className="alert alert-primary" role="alert">
        <i className="fas fa-info-circle" /> {MessagesAide[etape]}
    </div>
);

const Etape1 = ({ etapeSuivante }) => {
    /* Sous-composant */
    const CarteE1 = ({ type }) => (
        <div className="col-12 col-md-6 col-xl-4">
            <div className="card text-center mb-3">
                <span className="mt-3 text-dark"><i className={`fas fa-5x ${type.Icone}`} /></span>
                <div className="card-body">
                    <h5 className="card-title">
                        <button type="button" className="btn btn-lg btn-primary" onClick={() => etapeSuivante(type)}>
                            {type.Lib}
                        </button>
                    </h5>
                    <i className="card-text">{type.Description}</i>
                </div>
            </div>
        </div>
    );

    return (
        <div className="row justify-content-center">
            {Types.map((type, i) => <CarteE1 key={i} type={type} />)}
        </div>
    );
};

const Etape2 = ({ etapeSuivante, prestations }) => {
    /* Sous-composant */
    // icone
    const Icone = ({ path, couleur }) => (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={35} height={35} style={{filter: "invert(1)"}}>
            <image xlinkHref={path} width={35} height={35}/>
        </svg>
    );
    // bouton
    const BoutonE2 = ({ prest }) => (
        <div className="col-12 col-sm-6 col-lg-4 col-xl-3">
            <button 
                type="button"
                className="d-flex justify-content-start btn btn-light btn-lg btn-block mb-3"
                style={prest.Couleur ? { borderColor: prest.Couleur } : { borderColor: 'black' }}
                onClick={() => etapeSuivante(prest)} 
                title={prest.Libelle}
            >
                {prest.Icone ?
                    <span className="d-flex align-items-center justify-content-center" style={{ height: 37, width: 37, borderRadius: '50%', backgroundColor: prest.Couleur ? prest.Couleur : 'black' }}>
                        <Icone path={prest.Icone} couleur={prest.Couleur} /> {' '}
                    </span> : null}
                <span className="w-75 text text-truncate ml-3" style={prest.Couleur ? { color: prest.Couleur } : { color: 'black' }}>{prest.Libelle}</span>
            </button>
        </div>
    );

    return (
        <div className="row">
            {prestations && prestations.length > 0
                ? prestations.map((prest, i) => <BoutonE2 key={i} prest={prest} />)
                : etapeSuivante(PrestVide)}
        </div>
    );
};

const Etape3 = ({
    defaultValues, handleChange, handleSubmit, inputs, uppy
}) => (
    <Form
        defaultValues={defaultValues}
        onChange={formState => handleChange(formState)}
        onSubmit={submittedValues => handleSubmit(submittedValues)}
    >
        {formApi => (
            <form onSubmit={formApi.submitForm}>
                <div className="row">
                    <div className="col-12 col-xl-8">
                        <div className="form-group required">
                            <label htmlFor="Objet">Objet</label>
                            <Texte
                                field="Objet"
                                id="Objet"
                                type="text"
                                refRef={inputs.Objet}
                                maxLength={100}
                            />
                            <div className="invalid-feedback">Veuillez renseigner un objet</div>
                        </div>
                        <div className="form-group required">
                            <label htmlFor="Memo">Message</label>
                            <ZoneTexte
                                field="Memo"
                                id="Memo"
                                type="text"
                                rows={8}
                                refRef={inputs.Memo}
                            />
                            <div className="invalid-feedback">Veuillez saisir un message</div>
                        </div>
                    </div>
                    <div className="col-12 col-xl-4" style={{alignSelf: "center"}}>
                        <div className="form-group optionnal">
                            <label htmlFor="inputPJ">Pièces jointes</label>
                            <div className="uppy-container mb-3">
                                <Dashboard
                                    uppy={uppy}
                                    width={10000}
                                    height={225}
                                    locale={francaisDashboard}
                                    hideUploadButton
                                    proudlyDisplayPoweredByUppy={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group text-center">
                    <button type="submit" className="btn btn-success" ref={inputs.Envoyer}>
                        Envoyer le message
                    </button>
                </div>
                {/* <div style={{ position: "fixed", bottom: 20, right: 20 }}>
                    <button className="btn btn-success" type="submit" ref={inputs.Envoyer}>
                        Envoyer le message
                    </button>
                </div> */}
            </form>
        )}
    </Form>
);

function recurseenvoyer(nbFichiers, numFichier, numAuto, sObjet, Memo, lesArcDocs, LsFichiers, bureau, action, prest, appelant) {
    numFichier+=1
    if(numFichier>nbFichiers) {
        envoyerMessageNGHorsPJ(numAuto, { Objet: sObjet, Memo: Memo, LesArcDocs: lesArcDocs, Bureau: bureau, Action: action, Prest: prest}).then((data) => {
            if (data && data > 0) {
                swal('Envoyé', 'Le message a été envoyé avec succès.', 'success');
                if (appelant.unblock) appelant.unblock();
                appelant.props.actions.mesObtenirMessages();
                appelant.props.history.push('/MaMessagerie');
            } else {
                swal('Erreur', 'Le message n&apos;a pas été envoyé.', 'error');
            }
            });
    } else {
        envoyerMessageNGPJ(numAuto, LsFichiers[numFichier-1]).then((data) => {
            if (data) {
                if (data.length>0) {
                    if (numFichier==1) {
                        lesArcDocs=data
                    } else {
                        lesArcDocs += "," + data
                    }
                }
                recurseenvoyer(nbFichiers, numFichier, numAuto, sObjet, Memo, lesArcDocs, LsFichiers, bureau, action, prest, appelant)
            } else {
                swal('Erreur', 'Le message n&apos;a pas été envoyé. (taille du fichier trop importante)', 'error');
            }
        });
    }
}

class PageEcrireNG extends Component {
    constructor(props) {
        super(props);

        this.inputs = [];
        this.inputs.Objet = React.createRef();
        this.inputs.Memo = React.createRef();
        this.inputs.Envoyer = React.createRef();

        this.uppy = Uppy({
            debug: false,
            autoProceed: true,
            restrictions: {
                maxFileSize: 209715200,
                maxNumberOfFiles: 10,
                allowedFileTypes: ['image/*', 'text/*', 'application/pdf'],
            },
            locale: francaisCore,
        })
            .on('upload', () => this.setState({ LsFichiers: [] }))
            .on('complete', this.handleComplete)
            .on('file-removed', this.handleFileRemoved)
            .run();

        this.defaultValues = {
            Objet: '',
            Memo: `Bonjour,\n\n\n\nCordialement\n${this.props.Nom}`,
        };

        this.state = {
            etape: 0,
            selection: [],
            prestations: [],
        };
    }

    componentWillUnmount() {
        this.uppy.close();
        if (this.unblock) this.unblock();
    }

    componentDidMount(){ 
        if(this.props.location.state && this.props.location.state.Incident) {
            this.etapeSuivante(Types[0])
        }
    }

    etapePrecedente = () => {
        this.setState(prevState => ({ etape: prevState.etape - 1, selection: prevState.selection.slice(0, -1) }));
    }

    etapeSuivante = (selection) => {
        //choix du bureau, chargement des prestations
        if(this.state.etape == 0) {
            obtenirPrestations(selection.IdBureau).then((data) => {
                this.setState({prestations : data})
                this.setState(prevState => ({ etape: prevState.etape + 1, selection: [...prevState.selection, selection] }));
            });
        } else {
            this.setState(prevState => ({ etape: prevState.etape + 1, selection: [...prevState.selection, selection] }));
        }   
    }

    handleChange = (formState) => {
        const affichePrompt =
            formState.values.Objet !== this.defaultValues.Objet || formState.values.Memo !== this.defaultValues.Memo;
        if (!this.unblock && affichePrompt) {
            this.unblock = this.props.history.block("Vous n'avez pas envoyé le message.<br>Voulez-vous vraiment quitter cette page ?");
        } else if (this.unblock && !affichePrompt) {
            this.unblock();
        }
    };

    handleFileRemoved = (file) => {
        this.setState(prevState => ({
            LsFichiers: prevState.LsFichiers.filter(fichier => fichier.Nom !== file.name),
        }));
    };

    handleComplete = (result) => {
        result.successful.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (upload) => {
                this.setState(prevState => ({
                    LsFichiers: [...prevState.LsFichiers, { Data: upload.target.result.split(',')[1], Nom: file.name }],
                }));
            };
            reader.readAsDataURL(file.data);
        });
    };

    handleSubmit = (submittedValues) => {
        this.inputs.Envoyer.current.disabled = true;

        const { Objet, Memo } = submittedValues;
        const { LsFichiers } = this.state;
        const numAuto = 0;
        const sObjet = this.props.location.pathname.includes('/Signaler') ? `Problème signalé : ${Objet}` : Objet;
        //const sMemo = `${Memo}\n${this.props.Nom}`;

        const ObjetValide = this.defaultValues.Objet !== Objet && !estVide(Objet);
        AfficherFeedback(this.inputs.Objet, ObjetValide);

        const MemoValide = this.defaultValues.Memo !== Memo;
        AfficherFeedback(this.inputs.Memo, MemoValide);

        if (!ObjetValide || !MemoValide) {
            this.inputs.Envoyer.current.disabled = false;
            return;
        }
        let bureau = this.state.selection[0].IdBureau
        let action = this.state.selection[0].Code
        let prest = this.state.selection[1].Code
        // envoyerMessageNG(numAuto, { Objet: sObjet, Memo: Memo, LsFichiers, Bureau: bureau, Action: action, Prest: prest}).then((data) => {
        //     if (data && data > 0) {
        //         swal('Envoyé', 'Le message a été envoyé avec succès.', 'success');
        //         if (this.unblock) this.unblock();
        //         this.props.actions.mesObtenirMessages();
        //         this.props.history.push('/MaMessagerie');
        //     } else {
        //         swal('Erreur', 'Le message n&apos;a pas été envoyé.', 'error');
        //         this.inputs.Envoyer.current.disabled = false;
        //     }
        // });

        let nbFichiers = 0
        if (LsFichiers != undefined) {
            nbFichiers = LsFichiers.length           
        }
        
        let numFichier = 0
        let lesArcDocs = ""
        recurseenvoyer(nbFichiers, numFichier, numAuto, sObjet, Memo, lesArcDocs, LsFichiers, bureau, action, prest, this)
        this.inputs.Envoyer.current.disabled = false;

    };


    render() {
        const { etape, selection } = this.state;

        let composant = null;
        switch (etape) {
        case 0:
            composant = <Etape1 etapeSuivante={this.etapeSuivante} />;
            break;
        case 1:
            composant = <Etape2 etapeSuivante={this.etapeSuivante} prestations={this.state.prestations} />;
            break;
        case 2:
            composant = <Etape3 etapeSuivante={this.etapeSuivante} {...this} />;
            break;
        default:
            break;
        }

        return (
            <React.Fragment>
                <Etapes etape={etape} selection={selection} etapePrecedente={this.etapePrecedente} />
                {/* <MessageAide etape={etape} /> */}
                {composant}
            </React.Fragment>
        );
    }
}
PageEcrireNG.displayName = 'PageEcrireNG';

function mapStateToProps({
    ProStore: {
        Pro : {Ind: { Nom }},
    },
}) {
    return { Nom };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(PageEcrireNG);



// WEBPACK FOOTER //
// ./src/components/MaMess/PageEcrireNG.js